export const YARDI_7_S = 'YARDI_7_S';
export const YARDI_7_S_COMMERCIAL = 'YARDI_7_S_COMMERCIAL';

export const IntegrationType = {
  Residential: YARDI_7_S,
  Commercial: YARDI_7_S_COMMERCIAL,
};

export enum IntegrationInputs {
  CheckPermissionButton = 'checkPermissionsButton',
}
